import type { HTMLAttributes, LegacyRef, ReactNode } from 'react';
import type { usePopper as useReactPopper } from 'react-popper';

export type ReactPopperProps = ReturnType<typeof useReactPopper>;

export interface PopperData {
  open: boolean;
  setPopperElement: LegacyRef<HTMLDivElement>;
  popperProps: ReactPopperProps;
}

export interface PopperProps extends HTMLAttributes<HTMLDivElement>, PopperData {
  children?: ReactNode;
}
